export default __webpack_public_path__ + "static/media/Ballroll_00251.381fe872.png";